module.exports = __webpack_public_path__ + "assets/img/qlg1.3527c2e3.jpg";